import React from 'react';
import { motion } from 'framer-motion';

const IRSlide01Title: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
      >
        <span className="relative inline-block mb-4">
          <span
            className="absolute inset-0 text-8xl md:text-9xl font-black text-[#06b6d4] blur-xl opacity-50"
            aria-hidden="true"
          >
            Lumen8
          </span>
          <span className="relative text-8xl md:text-9xl font-black bg-gradient-to-r from-[#0ea5e9] to-[#06b6d4] bg-clip-text text-transparent">
            Lumen8
          </span>
        </span>
      </motion.div>

      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="text-3xl md:text-4xl text-[#94a3b8] font-light mb-6"
      >
        AI-Powered Adaptive Learning for K-12
      </motion.h2>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.5 }}
        className="flex flex-col items-center gap-4"
      >
        <div className="h-px w-32 bg-gradient-to-r from-transparent via-[#0ea5e9] to-transparent" />
        <p className="text-lg text-[#475569]">June 2026</p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.8 }}
        className="flex items-center gap-12 mt-16"
      >
        <div className="text-center">
          <div className="text-4xl font-bold text-[#10b981]">4.1M</div>
          <div className="text-sm text-[#64748b]">Students in Australia</div>
        </div>
        <div className="h-12 w-px bg-[#334155]" />
        <div className="text-center">
          <div className="text-4xl font-bold text-[#f59e0b]">10+</div>
          <div className="text-sm text-[#64748b]">Year Customer Lifetime</div>
        </div>
      </motion.div>
    </div>
  );
};

export default IRSlide01Title;
